// 003: the join screens' frame: the no-school product header "Akaiva Edu Power" (R-9; decision
// 2026-10-03) above one centred column (max 440 on the web, 16 px gutters on phones).
import type { ReactNode } from "react";
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
  View,
} from "react-native";

import { AuthCard } from "@/auth/ui/AuthCard";
import { makeStyles } from "@/theme/makeStyles";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    screen: { flex: 1, backgroundColor: t.color.background },
    scroll: {
      flexGrow: 1,
      alignItems: "center",
      paddingHorizontal: t.space.lg,
      paddingVertical: t.space.x2l,
    },
    column: { width: "100%", maxWidth: 440, gap: t.space.lg },
    fill: { flex: 1 },
  }),
);

export function JoinLayout({
  children,
  testID,
  header = true,
  title,
}: {
  children: ReactNode;
  testID?: string;
  /** False inside the parent area, which has its own header. */
  header?: boolean;
  /** The page heading in the sign-in frame (signed-out and first-run screens). */
  title?: string;
}) {
  const styles = useStyles();
  // Signed-out and first-run screens share the Akaiva sign-in frame with log in and sign up, so the
  // first screen after a QR scan looks like the product, and keeps the keyboard clear on phones.
  if (header)
    return (
      <AuthCard title={title ?? "Join your school"} testID={testID}>
        {children}
      </AuthCard>
    );
  return (
    <View style={styles.screen} testID={testID}>
      {/* Phones: the code field and its button stay above the keyboard. */}
      <KeyboardAvoidingView
        style={styles.fill}
        behavior={Platform.OS === "web" ? undefined : "padding"}
      >
        <ScrollView
          contentContainerStyle={styles.scroll}
          keyboardShouldPersistTaps="handled"
          role="main"
        >
          <View style={styles.column}>{children}</View>
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
}
